import type { PromiseThunkAction } from '@ms/yammer-data/dist/types';
import { defaultLocale } from '@ms/yammer-i18n';
import { setLocale } from '@ms/yammer-i18n-react';
import { reportError } from '@ms/yammer-telemetry';
import { getContext } from 'teams/context';

type SetLocaleFromTeams = () => PromiseThunkAction<void>;
export const setLocaleFromTeams: SetLocaleFromTeams = () => async (dispatch) => {
  try {
    const { locale } = await getContext();
    dispatch(setLocale(locale));
  } catch (error: unknown) {
    dispatch(setLocale(defaultLocale));

    reportError({
      error,
      eventProperties: {
        contextMessage: `Unable to get Teams context. Falling back to ${defaultLocale} locale.`,
        errorCode: 'GetTeamsContextFailed',
      },
      sendToConsole: false,
    });
  }
};
